import logoLeon from "assets/img/enarm-apex-logo-leon.png";

// `done` is kept for backward-compatible callers but no longer changes the animation
export default function LogoLoader({ size = 152, label = "Cargando...", fullScreen = true, done = false }) {
	const content = (
		<div className="flex flex-col items-center justify-center gap-4">
			<div className="relative flex items-center justify-center" style={{ width: size, height: size }}>
				<span
					className="absolute inset-0 rounded-full animate-ping"
					style={{ backgroundColor: "rgba(99, 102, 241, 0.25)" }}
				/>
				<div className="relative animate-pulse" style={{ width: size * 0.72, height: size * 0.72 }}>
					<img
						src={logoLeon}
						alt="ENARM Apex"
						className="absolute inset-0"
						style={{ width: "100%", height: "100%", objectFit: "contain" }}
					/>
				</div>
			</div>
			{label ? <p className="text-sm font-semibold text-gray-500">{label}</p> : null}
		</div>
	);

	if (!fullScreen) return content;

	return <div className="w-full min-h-screen flex items-center justify-center">{content}</div>;
}
